import { DELETE_CAT_SUCCESS, DELETE_CAT_FAILED,DELETE_CAT_ATTEMPT, RESET_DELETE_CAT} from '../../actions/types'
const INITIAL_STATE = {
    deleteMessage: null,
    deleteLoading: false,
    deleteSuccess: false,
    reset: false
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DELETE_CAT_ATTEMPT:
            return { ...state, deleteMessage: action.message, deleteLoading: true, deleteSuccess: false}
        case DELETE_CAT_SUCCESS:
            return { ...state, deleteMessage: action.message,  deleteLoading: false , deleteSuccess: true}
        case DELETE_CAT_FAILED:
            return { ...state, deleteMessage: action.message , deleteLoading: false , deleteSuccess: true}
        case RESET_DELETE_CAT:
            return { ...state, deleteMessage: null, deleteLoading: false, deleteSuccess: false, reset: true }
       default:
            return state;
    }
}